import { connect } from "react-redux";

import defaultRoomImage from "../../image/default-hotel-image.svg";
import defaultRoomImageStyle2 from "../../image/hotel-vector.svg";
import LayoutConfig from "../../Config/layoutConfig";
import DomesticHotelDetailSafarmarketRateItem from "./DomesticHotelDetailSafarmarketRateItem";

const DomesticHotelDetailSafarmarketRoomItem = props => {
  const { availabilityItem } = props;

  let imageUrl = LayoutConfig.themeClassName === "style-2" ? defaultRoomImageStyle2 : defaultRoomImage;
  if (availabilityItem?.rooms[0]?.image){
    imageUrl = availabilityItem.rooms[0].image
  }

  return (
    <>
      {availabilityItem?.rates?.map((rate,rateIndex) => {
        return <DomesticHotelDetailSafarmarketRateItem 
          key={rate.bookingToken} 
          rate={rate} 
          selectedRoomToken={props.selectedRoomToken}
          selectRoomHandle={props.selectRoomHandle}
          duration={props.duration} 
          setCount={props.setCount}
          count={props.count}
          availabilityItem={availabilityItem}
          availabilityIndex={props.availabilityIndex}
          rateIndex={rateIndex}
        />;
      })}
    </>
  )
}

const mapStateToProps = (state) => ({
  error: state.VisualData.error,
  Dictionary: state.VisualData.Dictionary
});

export default connect(mapStateToProps)(DomesticHotelDetailSafarmarketRoomItem);